import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import { useDispatch, useSelector } from "react-redux";
import ModalHistorialConsumos from "../../../autorizaciones/gestionAuditoria/ModalHistorialConsumos";
import { FetchDataAfiliado } from "../../../../actions/reclamos/reclamosActions";
import moment from "moment";
import "moment/locale/es";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const AfiliadoMenu = ({ afiliado, solicitud }) => {

  const { dataAfiliado } = useSelector((state) => state.reclamos);
  const [edadAfiliado, setEdadAfiliado] = useState(0);
  const dispatch = useDispatch();
  const [openModalConsumos, setOpenModalConsumos] = useState(false);

  useEffect(() => {
    dispatch(FetchDataAfiliado(afiliado));
  }, [dispatch]);

  useEffect(() => {
    setEdadAfiliado(
      moment().diff(moment(dataAfiliado?.fecha_nacimiento), "years", false)
    );
  }, [dataAfiliado]);


  return (
    <React.Fragment>
      <Typography
        variant="h6"
        style={{
          textDecoration: "underline",
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Información Beneficiaria/o
        <Tooltip title="Consumos">
          <Button
            style={{ marginTop: -5, marginLeft: 25 }}
            onClick={() => setOpenModalConsumos(true)}
          >
            <NoteAddIcon fontSize="large" />
          </Button>
        </Tooltip>
      </Typography>
      {openModalConsumos && (
        <ModalHistorialConsumos
          open={openModalConsumos}
          onClose={() => {
            setOpenModalConsumos(false);
          }}
          afiliado={dataAfiliado}
        />
      )}
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Beneficiaria/o:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {dataAfiliado?.apellido_y_nombre}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Correo electrónico:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {solicitud?.email}
            </TableCell>
          </TableRow>
            <TableRow>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                Carnet:
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                {dataAfiliado?.carnet}
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                Edad:
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                {edadAfiliado}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                Cuil:
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                {dataAfiliado?.cuil}
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                Teléfono:
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                {solicitud?.telefono}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                Fecha de Nac:
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                {new Date(dataAfiliado?.fecha_nacimiento).toLocaleString(
                  "es",
                  optionsfecha
                )}
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                Celular:
              </TableCell>
              <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                {solicitud?.celular}
              </TableCell>
            </TableRow>
          </TableBody>
      </Table>
      <Grid
        style={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox checked={dataAfiliado?.incapacitado === 1} disabled />
          }
          label={
            <Typography style={{ color: "black" }}>Persona con discapacidad</Typography>
          }
        />
        <FormControlLabel
          control={
            <Checkbox checked={dataAfiliado?.judicializado === true} disabled />
          }
          label={
            <Typography style={{ color: "black" }}>Judicializado</Typography>
          }
        />
      </Grid>
    </React.Fragment>
  );
};
